import React from "react";
import { motion, useReducedMotion } from "framer-motion";

const OFFSETS = {
  up: { y: 52 },
  down: { y: -36 },
  left: { x: -44 },
  right: { x: 44 },
  none: {},
};

export default function ScrollReveal({
  children,
  className = "",
  delay = 0,
  direction = "up",
  amount = 0.2,
  once = true,
  as = "div",
}) {
  const reduceMotion = useReducedMotion();
  const MotionTag = motion[as] || motion.div;
  const offset = OFFSETS[direction] || OFFSETS.up;

  if (reduceMotion) {
    return <div className={className}>{children}</div>;
  }

  return (
    <MotionTag
      className={className}
      initial={{ opacity: 0, ...offset }}
      whileInView={{ opacity: 1, x: 0, y: 0 }}
      viewport={{ once, amount, margin: "0px 0px -48px 0px" }}
      transition={{
        duration: 0.75,
        delay,
        ease: [0.22, 1, 0.36, 1],
      }}
    >
      {children}
    </MotionTag>
  );
}
